import React from "react";
import classNames from "classnames";
import styles from "./MomentCard.module.css";

export const MomentCard = ({
  title,
  description,
  image,
  location,
  dateRange,
  packagesAvailable,
  endDate,
  className,
  onClick,
  href,
  imageStyle,
  ...props
}) => {
  return (
    <a
      className={classNames(styles.card, className)}
      onClick={onClick}
      {...props}
      href={href || "#"}
    >
      <div className={styles.cardInner}>
        {/* Image Section */}
        <img
          src={image || "https://placehold.co/329x260"}
          alt={title}
          className={styles.image}
          style={imageStyle}
        />

        {/* Location and Date Band */}
        {(location || dateRange) && (
          <div className={styles.locationBand}>
            <div className={styles.locationContent}>
              {location && <div className={styles.location}>{location}</div>}
              {dateRange && <div className={styles.dateRange}>{dateRange}</div>}
            </div>
          </div>
        )}

        {/* Content Section */}
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          {description && (
            <div className={styles.description}>{description}</div>
          )}

          {/* Footer with package info */}
          {packagesAvailable && (
            <div className={styles.footer}>
              <div className={styles.packageInfo}>
                <span className={styles.packageCount}>
                  {packagesAvailable} package
                  {packagesAvailable !== 1 ? "s" : ""} available
                </span>
                <div className={styles.divider}>|</div>
                {endDate && (
                  <span className={styles.endDate}>Ends {endDate}</span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </a>
  );
};
